import React from 'react';
import { render } from 'react-dom'

import { RootContainer } from './internal'

render(<RootContainer />, document.getElementById('root'))
